import React, { SVGProps } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import FsBody from 'ui-elements/typography/FsBody';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import { ImageWrapper, StyledButton } from './SubBoard.style-elements';
import { useStyles } from './SubBoard.style';

interface SubBoardProps {
  title: string;
  imageComponent: SVGProps<SVGElement>;
  backgroundColor?: string;
  buttonLabel?: string;
  buttonUrl?: Routes;
}

const SubBoard: React.FC<SubBoardProps> = ({
  title,
  imageComponent,
  backgroundColor,
  buttonLabel,
  buttonUrl,
  children,
}) => {
  const {
    title: titleClass,
    imageWrapper: imageWrapperClass,
    description: descriptionClass,
  } = useStyles({
    backgroundColor,
  })();
  return (
    <Box>
      <ImageWrapper className={imageWrapperClass}>
        {imageComponent}
      </ImageWrapper>
      <FsSubtitle className={titleClass}>{title}</FsSubtitle>
      <FsBody className={descriptionClass}>{children}</FsBody>
      {buttonLabel && (
        <StyledButton
          variant="contained"
          color="primary"
          component={Link}
          to={buttonUrl}
        >
          {buttonLabel}
        </StyledButton>
      )}
    </Box>
  );
};

export default SubBoard;
